import { Component, InputSignal, InputSignalWithTransform, ViewEncapsulation, booleanAttribute, input } from '@angular/core';

export type MaterialSelectableInputPanelControlAlignment = 'center' | 'start';

@Component({
  selector: 'td-wb-material-selectable-input-panel',
  template: '<ng-content />',
  styleUrls: ['material-selectable-input-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'td-wb-material-selectable-input-panel',
    '[class.td-wb-material-selectable-input-panel--error]': 'error()',
    '[class.td-wb-material-selectable-input-panel--control-start]': 'controlAlignment() === "start"'
  }
})
export class MaterialSelectableInputPanelComponent {
  readonly error: InputSignalWithTransform<boolean, unknown> = input<boolean, unknown>(false, {
    transform: booleanAttribute
  });

  readonly controlAlignment: InputSignal<MaterialSelectableInputPanelControlAlignment> =
    input<MaterialSelectableInputPanelControlAlignment>('center');
}

